import { useMemo, useState } from "react";
import { FormProvider, useForm, useFormContext, UseFormHandleSubmit } from "react-hook-form";
import Button from "components/atoms/buttons/Button";
import MerchDropModal from "./MerchDropModal";

type Props = {
  magnetDetails: {
    brand_name: string;
    brand_id: string;
    name: string;
    image_url: string;
  };
  handleSubmit: UseFormHandleSubmit<MementoFormType>;
  handlePublishMerchDrop: (formData: MementoFormType) => void;
  onClose: () => void;
  disabled?: boolean;
};

function BottomBarButtons({
  handleGoBackButtonClick,
  handlePublishButtonClick,
  handleSubmit,
  disabled = false,
}: {
  handleSubmit: UseFormHandleSubmit<MementoFormType>;
  handleGoBackButtonClick: () => void;
  handlePublishButtonClick: (formData: MementoFormType) => void;
  disabled: boolean;
}) {
  return (
    <>
      <Button
        disabled={disabled}
        variant="whiteOutline"
        text="GO BACK"
        additionalClasses="xl:px-6 xl:py-3 xl:text-xs 2xl:text-sm 2xl:px-8 2xl:py-4"
        onClick={handleGoBackButtonClick}
      />

      <Button
        disabled={disabled}
        text="PUBLISH"
        variant="magnetiqSolid"
        additionalClasses="xl:px-6 xl:py-3 xl:text-xs 2xl:text-sm 2xl:px-8 2xl:py-4"
        onClick={handleSubmit(handlePublishButtonClick)}
      />
    </>
  );
}

function MerchDropBrandPreviewModalContainer({
  magnetDetails,
  onClose,
  handlePublishMerchDrop,
  handleSubmit,
  disabled = false,
}: Props) {
  const [currentFormStep, setCurrentFormStep] = useState<number>(0);
  const { getValues } = useFormContext<MementoFormType>();
  const merchDropData = getValues();

  const getMerchDropImage = useMemo(
    () => (merchDropData.thumbnail ? URL.createObjectURL(merchDropData.thumbnail) : merchDropData.thumbnail_url),
    [merchDropData.thumbnail, merchDropData.thumbnail_url],
  );

  const handleSetCurrentFormStep = (formStep: number) => {
    setCurrentFormStep(formStep);
  };

  const formMethods = useForm<MerchDropFormData>({
    mode: "onChange",
  });

  return (
    <FormProvider
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...formMethods}
    >
      <MerchDropModal
        brandName={magnetDetails.brand_name}
        brandId={magnetDetails.brand_id}
        magnetName={magnetDetails.name}
        magnetImageUrl={magnetDetails.image_url}
        merchDropDescription={merchDropData.description}
        merchDropName={merchDropData.name}
        merchDropImageUrl={getMerchDropImage}
        onClose={onClose}
        currentFormStep={currentFormStep}
        handleSetCurrentFormStep={handleSetCurrentFormStep}
        getActionButtons={
          <BottomBarButtons
            disabled={disabled}
            handleGoBackButtonClick={onClose}
            handlePublishButtonClick={handlePublishMerchDrop}
            handleSubmit={handleSubmit}
          />
        }
        merchDropOptions={merchDropData.options}
      />
    </FormProvider>
  );
}
export default MerchDropBrandPreviewModalContainer;
